<template>
    <div>

        <nav class="nav d-flex justify-content-between">
            <div class="d-flex align-items-center mt-4">
                <h3 class="h5 p-0 mb-0 pr-3">Cambiali</h3>
                <!-- ml-auto -->
                <button type="button" @click="searchRates()" class="btn btn-success btn-sm " style="margin-left:10px">
                    Cerca
                </button>
            </div>

            <!--
                        <div class="form-group ">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" v-model="filter_shown" value="place">
                                <label class="form-check-label">Luogo Emissione</label>

                                <span style="margin-right: 26px;">   </span>
                                <input class="form-check-input" type="checkbox" v-model="filter_shown" value="date">
                                <label class="form-check-label">Data emissione</label>

                                <span style="margin-right: 26px;">   </span>
                                <input class="form-check-input" type="checkbox" v-model="filter_shown" value="amount">
                                <label class="form-check-label">Importo in cifre</label>

                                <span style="margin-right: 26px;">   </span>
                                <input class="form-check-input" type="checkbox" v-model="filter_shown" value="date_end">
                                <label class="form-check-label">Scadenza</label>

                                <span style="margin-right: 26px;">   </span>
                                <input class="form-check-input" type="checkbox" v-model="filter_shown" value="beneficiary">
                                <label class="form-check-label">Beneficiario</label>

                                <span style="margin-right: 26px;">   </span>
                                <input class="form-check-input" type="checkbox" v-model="filter_shown" value="debtor">
                                <label class="form-check-label">Debitore</label>

                                <span style="margin-right: 26px;">   </span>
                                <input class="form-check-input" type="checkbox" v-model="filter_shown" value="letters_amount">
                                <label class="form-check-label">Importo in Lettere</label>

                                <span style="margin-right: 26px;">   </span>
                                <input class="form-check-input" type="checkbox" v-model="filter_shown" value="name">
                                <label class="form-check-label">Domiciliazione Nome</label>

                                <span style="margin-right: 26px;">   </span>
                                <input class="form-check-input" type="checkbox" v-model="filter_shown" value="is_paid">
                                <label class="form-check-label">Rata Pagata</label>

                                <span style="margin-right: 26px;">   </span>
                                <input class="form-check-input" type="checkbox" v-model="filter_shown" value="paid_date">
                                <label class="form-check-label">Data Pagamento Rata</label>

                                <span style="margin-right: 26px;">   </span>
                                <input class="form-check-input" type="checkbox" v-model="filter_shown" value="is_presented">
                                <label class="form-check-label">Rata In Distinta</label>

                                <span style="margin-right: 26px;">   </span>
                                <input class="form-check-input" type="checkbox" v-model="filter_shown" value="presented_date">
                                <label class="form-check-label">Rata Data Distinta</label>


                                <span style="margin-right: 26px;">   </span>
                            </div>
                        </div>

                        <div class="form-group">
                            <div class="form-check">
                                <span style="margin-right: 26px;">   </span>
                                <input class="form-check-input" type="checkbox" @click="filter_shown=['debtor','is_paid','paid_date','amount']">
                                <label class="form-check-label">Gestione Pagamento</label>
                            </div>
                        </div>
                        -->
        </nav>
        <div class="table-responsive-lg margin-top-20">

            <nav aria-label="Page navigation example">
                <div v-for="(n, index) in pages" class="page-item"
                     v-bind:class="{'active': currentPage == n}"><a
                        class="page-link"
                        @click="searchRates(n)">{{n}}</a>
                </div>
            </nav>


            <table class="table table-sm table-striped table-bordered table-light">
                <thead>
                <tr>
                    <td>
                        <input type="text" class="form-control form-control-sm" id="inputCity" placeholder="Codice"
                               v-model="filter.amortization.code">
                    </td>


                    <td v-show="filter_shown.includes('date')" style="width:154px">

                        <div style="width:100%;float:left;">
                            <span style="float:left;font-size:11px;padding-top:10px;margin-right:2%;width:8%">Da</span>
                            <input type="date" class="form-control form-control-sm" id="inputCity"
                                   v-model="filter.amortization.dateIssueFrom" style="width:90%;float:left;">
                        </div>
                        <div style="width:100%;float:left;margin-top:4px">
                            <span style="float:left;font-size:11px;padding-top:10px;margin-right:2%;width:8%">Al</span><input
                                type="date" class="form-control form-control-sm" id="inputCity"
                                placeholder="Scadenza" style="width:90%;float:left;"
                                v-model="filter.amortization.dateIssueTo">
                        </div>

                    </td>
                    <td v-show="filter_shown.includes('debtor')">
                        <input type="text" class="form-control form-control-sm" id="inputCity"
                               v-model="filter.amortization.debtor_last_name"
                               placeholder="Debitore">
                    </td>
                    <td v-show="filter_shown.includes('date_end')" style="width:154px">
                        <div style="width:100%;float:left;">
                            <span style="float:left;font-size:11px;padding-top:10px;margin-right:2%;width:8%">Da</span>
                            <input type="date" class="form-control form-control-sm" id="inputCity"
                                   v-model="filter.rate.dateFrom" style="width:90%;float:left;">
                        </div>
                        <div style="width:100%;float:left;margin-top:4px">
                            <span style="float:left;font-size:11px;padding-top:10px;margin-right:2%;width:8%">Al</span><input
                                type="date" class="form-control form-control-sm" id="inputCity"
                                placeholder="Scadenza" style="width:90%;float:left;"
                                v-model="filter.rate.dateTo">
                        </div>
                    </td>
                    <td v-show="filter_shown.includes('beneficiary')">
                        <input type="text" class="form-control form-control-sm" id="inputCity"
                               v-model="filter.amortization.beneficiary"
                               placeholder="Beneficiario">
                    </td>

                    <td v-show="filter_shown.includes('name')">
                        <input type="text" class="form-control form-control-sm" id="inputCity"
                               v-model="filter.amortization.name"
                               placeholder="Domiciliazione">
                    </td>
                    <td v-show="filter_shown.includes('amount')">
                        <input type="text" class="form-control form-control-sm" id="inputCity"
                               v-model="filter.rate.amount"
                               placeholder="Importo">
                    </td>


                    <td v-show="filter_shown.includes('is_presented')">
                        <select class="form-control form-control-sm" id="inputCity"
                                v-model="filter.rate.isPresented">
                            <option value="">Tutte</option>
                            <option value="1">Si</option>
                            <option value="0">No</option>
                        </select>
                    </td>

                    <td v-show="filter_shown.includes('in_protest')">
                        <select class="form-control form-control-sm" id="inputCity"
                                v-model="filter.rate.inProtest">
                            <option value="">Tutte</option>
                            <option value="1">Si</option>
                            <option value="0">No</option>
                        </select>
                    </td>

                    <td v-show="filter_shown.includes('is_paid')">
                        <select class="form-control form-control-sm" id="inputCity"
                                v-model="filter.rate.isPaid">
                            <option value="">Tutte</option>
                            <option value="1">Si</option>
                            <option value="0">No</option>

                        </select>
                    </td>


                    <td v-show="filter_shown.includes('place')">
                        <input type="text" class="form-control form-control-sm" id="inputCity"
                               v-model="filter.amortization.place"
                               placeholder="Luogo Emissione">
                    </td>

                    <td v-show="filter_shown.includes('paid_date')">
                        <input type="date" class="form-control form-control-sm" id="inputCity"
                               v-model="filter.rate.paidDate"
                               placeholder="Data Pagamento Rata">
                    </td>


                    <td v-show="filter_shown.includes('presented_date')">
                        <input type="date" class="form-control form-control-sm" id="inputCity"
                               v-model="filter.amortization.presented_date"
                               placeholder="Data presentazione">
                    </td>


                    <td v-show="filter_shown.includes('letters_amount')">
                        <input type="text" class="form-control form-control-sm" id="inputCity"
                               v-model="filter.rate.amountString"
                               placeholder="Importo in Lettere">
                    </td>

                </tr>
                <tr>
                    <th scope="col">Codice</th>

                    <th scope="col" v-show="filter_shown.includes('date')">Data Emissione</th>
                    <th scope="col" v-show="filter_shown.includes('debtor')">Debitore</th>
                    <th scope="col" v-show="filter_shown.includes('date_end')">Scadenza Rata</th>
                    <th scope="col" v-show="filter_shown.includes('beneficiary')">Beneficiario</th>
                    <th scope="col" v-show="filter_shown.includes('name')">Domiciliazione</th>
                    <th scope="col" v-show="filter_shown.includes('amount')">Importo</th>


                    <th scope="col" v-show="filter_shown.includes('paid_date')">Data Pag. Rata</th>

                    <th scope="col" v-show="filter_shown.includes('is_presented')">InDistinta</th>
                    <th scope="col" v-show="filter_shown.includes('in_protest')">InProtesto</th>

                    <th scope="col" v-show="filter_shown.includes('is_paid')">Incassata</th>

                    <th scope="col" v-show="filter_shown.includes('presented_date')">Data Distinta</th>
                    <th scope="col" v-show="filter_shown.includes('place')">Luogo Emmissione</th>
                    <th scope="col" v-show="filter_shown.includes('type')">Tipo Cambiale</th>

                    <th scope="col" v-show="filter_shown.includes('letters_amount')">Importo in lettere</th>

                </tr>
                </thead>
                <tbody>

                <tr v-if="isLoading">
                    <td v-bind:colspan="filter_shown.length+1" align="center">Caricamento in corso...</td>
                </tr>
                <tr v-for="rate in rates">
                    <th scope="row">{{rate.amortization.code}}</th>
                    <td v-show="filter_shown.includes('date_end')">{{rate.amortization.date_end | moment('D-M-Y') }}
                    </td>
                    <td v-show="filter_shown.includes('debtor')">{{rate.amortization.debtor_last_name}}
                        {{rate.amortization.debtor_first_name}}
                    </td>
                    <td v-show="filter_shown.includes('date')">{{rate.date | moment('D-M-Y')}}</td>
                    <td v-show="filter_shown.includes('beneficiary')">{{rate.amortization.beneficiary}}</td>
                    <td v-show="filter_shown.includes('place')">{{rate.amortization.place}}</td>
                    <td v-show="filter_shown.includes('name')">{{rate.amortization.pay_name}}</td>
                    <td v-show="filter_shown.includes('amount')">
                        {{formatPrice(rate.amount)}} €
                    </td>
                    <td v-show="filter_shown.includes('is_presented')">
                        <input type="checkbox" v-model="rate.is_presented" @change="updateAmortization(rate)">
                    </td>
                    <td v-show="filter_shown.includes('in_protest')">
                        <input type="checkbox" v-model="rate.in_protest" @change="updateAmortization(rate)">
                    </td>

                    <td v-show="filter_shown.includes('is_paid')">
                        <input type="checkbox" v-model="rate.is_paid" :value="1" @change="updateAmortization(rate)">
                    </td>


                    <td v-show="filter_shown.includes('paid_date')">{{rate.paid_date | moment('D-M-Y')}}</td>


                    <td v-show="filter_shown.includes('presented_date')">{{rate.presented_date | moment('D-M-Y')}}</td>

                    <td v-show="filter_shown.includes('type')">{{rate.amortization.type}}</td>
                    <td v-show="filter_shown.includes('letters_amount')">{{rate.amount_string}}</td>

                </tr>

                </tbody>
            </table>


        </div>
    </div>

</template>

<script>
    import axios from 'axios'

    export default {
        name: 'TableShort',
        data: function () {
            return {
                currentPage: 1,
                pages: 0,
                isLoading: false,
                rates: [],
                filter_shown: [
                    'beneficiary',
                    'name',
                    'amount',
                    'date_end',
                    'debtor',
                    'date',
                    'is_paid',
                    'is_presented',
                    'in_protest'
                ],
                filter: {
                    amortization: {
                        name: '',
                        beneficiary: '',
                        place: '',
                        code: ''
                    },
                    rate: {
                        dateFrom: '',
                        dateTo: '',
                        amountString: '',
                        isPaid: '',
                        isPresented: '',
                        inProtest: '',
                        presentedDate: '',
                        paidDate: '',
                        amount: '',
                    }
                }
            }
        },
        methods: {
            formatPrice(value) {
                let val = (value / 1).toFixed(2).replace('.', ',')
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            },
            updateAmortization: function (rate) {
                let params = {
                    is_paid: rate.is_paid,
                    is_presented: rate.is_presented,
                    in_protest: rate.in_protest,
                }
                axios.patch(process.env.VUE_APP_API_BASE_URL + '/api/v1/amortization-rate/' + rate.id, params)
                    .then(function (response) {

                    })
            },
            searchRates: function (page = 1) {
                var $vm = this
                $vm.currentPage = page
                $vm.isLoading = true
                $vm.rates = []
                let limit = 100
                let offset = (page - 1) * limit
                axios.post(process.env.VUE_APP_API_BASE_URL + '/api/v1/amortization-rate/search?offset=' + offset + '&limit=' + limit, {filter: $vm.filter})
                    .then(function (response) {
                        $vm.isLoading = false
                        $vm.rates = response.data.data
                        $vm.pages = response.data.pages
                    })
            }
        }
    }


</script>

<style scope>

    table th, table td {
        font-size: 14px !important;
    }

    .nav-scroller {
        position: relative;
        z-index: 2;
        height: 2.75rem;
        overflow-y: hidden;
    }

    .nav-scroller .nav {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: nowrap;
        flex-wrap: nowrap;
        padding-bottom: 1rem;
        margin-top: -1px;
        overflow-x: auto;
        text-align: center;
        white-space: nowrap;
        -webkit-overflow-scrolling: touch;
    }

    .nav-scroller .nav-link {
        padding-top: .75rem;
        padding-bottom: .75rem;
        font-size: .875rem;
    }

    .margin-top-20 {
        margin-top: 20px;
    }


    .page-item {
        width: 30px;
        height: 30px;
        text-align: center;
        float: left;
        margin-bottom: 4px;
    }

</style>
